/* eslint-disable no-extra-parens */
/* eslint-disable id-match */
import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import {injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import {Checkbox} from '@material-ui/core';
import {createSecurePayment} from '../utils/apiHandlers';
import PaymentContainer from '../components/PaymentContainer/PaymentContainer';

const SecurePayment = (props) => {
  const {classes, intl, history} = props;
  const messages = (id) => intl.formatMessage({id});
  const token = new URLSearchParams(window.location.search).get('token');
  const displayUserOwnCardFields = true;

  const [useCardForBoth, setUseCardForBoth] = useState(true);
  const [policyType, setPolicyType] = useState('');
  const [isFirstCard, setIsFirstCard] = useState(() => {
    const storedIsFirstCard = sessionStorage.getItem('isFirstCard');

    // If not set in sessionStorage, default to true
    return storedIsFirstCard === null ? true : storedIsFirstCard === 'true';
  });
  const [isVerifyingPayment, setIsVerifyingPayment] = useState(false);
  const [formKey, setFormKey] = useState(0); // Add a key state to force re-render

  const cascoAndMandatoryPaymentHandler = (numberOfPaymentsMandatory, numberOfPaymentsCasco) => {
    if (!isFirstCard) {
      return {paymentCasco: numberOfPaymentsCasco, paymentMandatory: '0'};
    }
    if (useCardForBoth) {
      return {paymentCasco: numberOfPaymentsCasco, paymentMandatory: numberOfPaymentsMandatory};
    }
    return {paymentCasco: '0', paymentMandatory: numberOfPaymentsMandatory};
  };

  useEffect(() => {
    const policyTypeFromHash = window.location.hash.replace('#', '');
    setPolicyType(policyTypeFromHash === 'Comprehensive' ? 'מקיף' : 'צד ג׳');
  }, []);

  const nextStepHandler = (resetForm) => {
    if (!isFirstCard || useCardForBoth) {
      history.push('/thankyou');
    }
    setIsFirstCard(false);
    sessionStorage.setItem('isFirstCard', 'false');

    // Instead of just calling resetForm, we'll increment the formKey to force re-render
    resetForm();
    setFormKey(prevKey => prevKey + 1);
  };

  const onPaymentSubmit = async (values, {setErrors, resetForm}) => {
    setIsVerifyingPayment(true);
    // eslint-disable-next-line max-len
    const cascoAndMandatoryPayment = cascoAndMandatoryPaymentHandler(String(values.paymentMandatory), String(values.paymentCasco));
    const {payment, creditcardOwnerRelationToPolicyOwner, ...valuesForReq} = values;

    const paymentDetails = {
      ...valuesForReq,
      month: String(values.month).padStart(2, '0'),
      year: String(values.year),
      ...cascoAndMandatoryPayment,
    };

    const requestData = {
      paymentDetails,
      token,
    };

    try {
      const response = await createSecurePayment(requestData);
      if (response.isSuccess) {
        // Only reset form and change state if it's the first card
        nextStepHandler(resetForm);
      } else {
        setErrors({creditCardNumber: messages(`${response.friendlyError}`)});
      }
    } catch (error) {
      console.error('Payment submission error:', error);
      setErrors({creditCardNumber: messages('משהו השתבש')});
    } finally {
      setIsVerifyingPayment(false);
    }
  };

  const handleCardToggle = () => {
    setUseCardForBoth(!useCardForBoth);
  };

  return (
    <section>
      <div className={`${classes.offersStep}`}>
        <React.Fragment>
          <PaymentContainer
            displayAdditionalFields
            isVerifyingPayment={isVerifyingPayment}
            onPaymentSubmit={onPaymentSubmit}
            displayUserOwnCardFields={displayUserOwnCardFields}
            formKey={formKey} // Pass the key to force re-render
            isUseCardForBoth={useCardForBoth}
            isFirstCard={isFirstCard}
            policyType={policyType}
          >
            {isFirstCard ? (
              <div>
                <Checkbox
                  name='isUseForBothCheckBox'
                  id='isUseForBothCheckBox'
                  onChange={handleCardToggle}
                  checked={useCardForBoth}
                />
                <span>{messages('secure.payment.use.for.both.check.box')}</span>
              </div>
            ) : (
              <div>
              כרטיס החובה תקין, נשאר להזין את כרטיס לתשלום ביטוח
                {' ' + policyType}
              </div>
            )}
          </PaymentContainer>
        </React.Fragment>
      </div>
    </section>
  );
};

SecurePayment.propTypes = {
  classes: PropTypes.object,
  history: PropTypes.object,
  intl: PropTypes.object,
  width: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs']).isRequired,
};

const useStyles = theme => ({
  // Styles remain unchanged...
  backdrop: {
    zIndex: 9,
  },
  FullcoverMissingFieldsForm: {
    '& .msg': {
      color: theme.palette.secondary.main,
      fontSize: theme.typography.pxToRem(14.9),
      fontWeight: 600,
      lineHeight: 1.2,
      marginBottom: 20,
    },
    padding: 50,
  },
  innerBreadcrumbs: {
    [theme.breakpoints.up(769)]: {display: 'none'},
    '& .MuiStepper-root': {
      marginBottom: 16,
      padding: 0,
      position: 'relative',
    },
  },
  mainCarTooltip: {
    [theme.breakpoints.up(1550)]: {marginLeft: 20},
    '& .icon': {height: 42},
  },
  mainCarTooltipBubble: {
    maxWidth: 220,
  },
  newClients: {
    margin: '5px 0 20px',
    [theme.breakpoints.down(768)]: {margin: '5px 16px 20px'},
  },
  noOffers: {
    '& .contact_us_loader': {
      margin: '30px 70px',
    },
    '& .img-container': {
      '& img': {
        maxWidth: 478,
        width: '100%',
      },
      marginTop: 50,
    },
    '& .text': {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(21),
    },
    '& button': {
      display: 'flex',
      fontWeight: 700,
      justifyContent: 'space-between',
      marginTop: 30,
    },
    padding: 10,
  },
  offersStep: {
    margin: '0 auto',
    maxWidth: 1180,
  },
  offersStepOffers: {
    '&>*:not(:last-child)': {
      marginBottom: 15,
    },
    backgroundColor: theme.palette.background.default,
    borderRadius: 12,
    [theme.breakpoints.down(768)]: {
      backgroundColor: 'transparent',
      borderRadius: 0,
      padding: '15px 0',
    },
    padding: 15,
  },
  summaryText: {
    [theme.breakpoints.down(768)]: {
      '& .bg': {
        background: theme.palette.type === 'light' ?
          'linear-gradient(180deg, #ECF9FE 0%, #FBFEFF 180px, #FFFFFF52 200px) 0% 0% no-repeat padding-box' :
          'linear-gradient(180deg, #272733 0%, #3b3b42 180px, #424242 200px) 0% 0% no-repeat padding-box',
        height: '200px',
        pointerEvents: 'none',
        position: 'absolute',
        right: -26,
        top: -16,
        width: '100vw',
        zIndex: -1,
      },
      '& > span': {fontWeight: 700},
      fontSize: theme.typography.pxToRem(20),
      fontWeight: 500,
      letterSpacing: '-0.5px',
      lineHeight: 1.2,
      margin: '0 16px',
      position: 'relative',
      top: -16,
      zIndex: 0,
    },
    color: theme.palette.secondary.main,
    fontSize: theme.typography.pxToRem(24.5),
    fontWeight: 600,
    margin: '0 16px',
    [theme.breakpoints.up(769)]: {margin: 0},
  },
  SummaryTitles: {
    '& .handelingFeeIcon': {
      marginRight: '5px',
    },
    '& h5': {
      color: theme.palette.text.secondary,
      display: 'flex',
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 500,
      lineHeight: 1.43,
      margin: '5px 0',
    },
    '& img': {
      height: '1.43em',
      marginLeft: '5px',
      width: 'auto',
      zIndex: 1,
    },
    [theme.breakpoints.down(768)]: {
      '& h5': {
        fontSize: theme.typography.pxToRem(14),
        margin: '0 16px',
      },
      marginBottom: 16,
      position: 'relative',
    },
  },
  withTooltip: {
    margin: [[0, 0, 10, 0]],
  },
});

export default withRouter(withStyles(useStyles)(injectIntl(SecurePayment)));
